/* Newsletter Popup - Paolina Roma (Dawn port).
   Behaviour identical to the Motion version:
   - shows after a delay, once every N days (cookie newsletterPopup_<sectionId>);
   - the native Shopify customer form reloads the page on submit, so a localStorage
     "pending" flag (newsletterPopup_<sectionId>_pending) drives the success state
     after the reload;
   - ESC / overlay / close button dismiss and set the cookie;
   - copy button uses execCommand first (navigator.clipboard rejects silently in
     some embedded contexts), clipboard API as fallback. */
(function () {
  'use strict';

  function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
  }

  function copyText(text) {
    var ok = false;
    try {
      var textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.setAttribute('readonly', '');
      textArea.style.position = 'fixed';
      textArea.style.left = '-9999px';
      document.body.appendChild(textArea);
      textArea.select();
      ok = document.execCommand('copy');
      document.body.removeChild(textArea);
    } catch (e) {
      ok = false;
    }
    if (ok) return Promise.resolve(true);
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).then(
        function () {
          return true;
        },
        function () {
          return false;
        }
      );
    }
    return Promise.resolve(false);
  }

  function initPopup(popup) {
    if (popup.dataset.nlpInit === 'true') return;
    popup.dataset.nlpInit = 'true';

    // In the theme editor the popup is either forced visible server-side
    // (editor preview checkbox) or must stay hidden: no live logic either way.
    if (popup.dataset.designMode === 'true') return;

    var sectionId = popup.dataset.sectionId;
    var COOKIE_NAME = 'newsletterPopup_' + sectionId;
    var STORAGE_KEY = COOKIE_NAME + '_pending';
    var delaySeconds = parseInt(popup.dataset.delaySeconds, 10);
    if (isNaN(delaySeconds)) delaySeconds = 5;
    var delayDays = parseInt(popup.dataset.delayDays, 10) || 30;

    var shown = false;
    var lastFocused = null;

    function getFocusable() {
      return Array.prototype.slice
        .call(popup.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])'))
        .filter(function (el) {
          return el.offsetParent !== null;
        });
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key === 'Tab') {
        var focusable = getFocusable();
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    function open() {
      if (shown) return;
      shown = true;
      lastFocused = document.activeElement;
      popup.classList.add('is-visible');
      document.addEventListener('keydown', onKeydown, true);
      var focusable = getFocusable();
      if (focusable.length) {
        try {
          focusable[0].focus({ preventScroll: true });
        } catch (e) {
          focusable[0].focus();
        }
      }
    }

    function close() {
      setCookie(COOKIE_NAME, 'true', delayDays);
      popup.classList.remove('is-visible');
      document.removeEventListener('keydown', onKeydown, true);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        try {
          lastFocused.focus({ preventScroll: true });
        } catch (e) {
          /* noop */
        }
      }
    }

    function showSuccessState() {
      var main = popup.querySelector('.pr-popup__main');
      var success = popup.querySelector('.pr-popup__success');
      if (main && success) {
        main.style.display = 'none';
        success.classList.add('is-active');
      }
    }

    // Close bindings (overlay, X, success close button).
    popup.addEventListener('click', function (event) {
      if (event.target.closest('[data-nlp-close]')) close();
    });

    // Copy discount code.
    var copyBtn = popup.querySelector('[data-nlp-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var codeEl = popup.querySelector('[data-nlp-code]');
        if (!codeEl) return;
        copyText(codeEl.textContent.trim()).then(function (ok) {
          if (!ok) return;
          copyBtn.classList.add('copied');
          setTimeout(function () {
            copyBtn.classList.remove('copied');
          }, 2000);
        });
      });
    }

    // Mark a pending submit before the native form navigation.
    var form = popup.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        try {
          localStorage.setItem(STORAGE_KEY, 'true');
        } catch (e) {
          /* noop */
        }
      });
    }

    // Pending submit from the previous page load?
    var pending = null;
    try {
      pending = localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      /* noop */
    }

    if (pending === 'true') {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (e) {
        /* noop */
      }
      if (popup.querySelector('[data-nlp-error]')) {
        // The submit failed server-side: reopen the form with the error visible.
        open();
        return;
      }
      showSuccessState();
      open();
      setCookie(COOKIE_NAME, 'true', delayDays);
      return;
    }

    if (getCookie(COOKIE_NAME)) return;

    setTimeout(open, delaySeconds * 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-newsletter-popup]').forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
